//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { previewProductListApi, previewProductEnableApi, previewProductDisableApi, previewProductDeleteApi } from '@/api/marketing/preview-product.js';
import { isShowOptions } from './enums';
export default {
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '商户名称',
        prop: 'name',
        defaultValue: '',
        type: 'input'
      }, {
        label: '上架状态',
        prop: 'isShow',
        defaultValue: '',
        type: 'select',
        options: {
          list: isShowOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 140
      }, {
        key: 'name',
        visible: true,
        label: "\u5546\u54C1\u540D\u79F0"
      }, {
        key: 'platId',
        visible: true,
        label: "\u5546\u57CE\u5546\u54C1ID",
        width: 100
      }, {
        key: 'image',
        visible: true,
        label: "\u5546\u54C1\u56FE",
        width: 100
      }, {
        key: 'price',
        visible: true,
        label: "\u5546\u54C1\u4EF7\u683C",
        width: 100
      }, {
        key: 'isShow',
        visible: true,
        label: "\u4E0A\u67B6\u72B6\u6001",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: isShowOptions
        }
      }, {
        key: 'updateTime',
        visible: true,
        label: "\u66F4\u65B0\u65F6\u95F4",
        width: 160
      }, {
        key: 'updater',
        visible: true,
        label: "\u64CD\u4F5C\u4EBA",
        width: 100
      }];
    }
  },
  methods: {
    getList: function getList(params) {
      return previewProductListApi(params);
    },
    //添加商品
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/marketing/preview-product/operate/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/preview-product/operate/".concat(row.id, "/").concat(operate)
      });
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this = this;
      var params = {
        id: row.id
      };
      var funcApi = row.isShow ? previewProductEnableApi : previewProductDisableApi;
      funcApi(params).then(function (res) {
        _this.$message.success('更新状态成功');
        _this.$refs.searchPage.refresh();
      }).catch(function () {
        _this.$message.error('更新状态失败');
        row.isShow = !row.isShow;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return previewProductDeleteApi(row.id);
      }).then(function () {
        _this2.$refs.searchPage.refresh();
        _this2.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    }
  }
};